import React from 'react';
import { Building2 } from 'lucide-react';
import { CompanyResource } from '../types';
import CompanyCard from './CompanyCard';

interface CompanyListProps {
  companies: CompanyResource[];
  loading: boolean;
  search: string;
}

const CompanyList: React.FC<CompanyListProps> = ({ companies, loading, search }) => {
  if (loading) {
    return (
      <div className="bg-white shadow rounded-lg p-8">
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
          <span className="ml-3 text-gray-600">Loading companies...</span>
        </div>
      </div>
    );
  }

  if (companies.length === 0) {
    return (
      <div className="bg-white shadow rounded-lg p-8 text-center">
        <Building2 className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">No companies found</h3>
        <p className="mt-1 text-sm text-gray-500">
          {search ? `No companies match "${search}"` : 'Get started by creating a company.'}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
      {companies.map((company) => (
        <CompanyCard key={company.id} company={company} />
      ))}
    </div>
  );
};

export default CompanyList;
